import type { FaireProductEntity } from "../../entity_types/product";

export const p_phm78kkqyz: FaireProductEntity = {
  token: "p_phm78kkqyz",
  type: "product",
  name: "Peruvian Pink Salt Dark Chocolate Bar",
  brandToken: "b_n34zp8ykn9",
  brandName: "Eidon Ionic Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/5268bb0049f4838d36cf6b9794c86ad0afe87ac5ec430f108848bf0ea883d6ed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/94b1e1a6bed80663e1f29e4e9e6e9ceab3a72f2f4dfbffb0023cf86ff218d60f.jpeg",
    "https://cdn.faire.com/fastly/7d15017ba1edbd42791124dadfacefff3dee732b8ec23ac4a80a2c9e333ffe6c.jpeg",
    "https://cdn.faire.com/fastly/059c8c75f4ff678bf370592375ce78f9a8d6c4a8279806e6e4588ac6731ca904.png",
    "https://cdn.faire.com/fastly/4a7937c0e8ca9227b34551360ecf90725ff578e2560c2818e649f15e9ef18b6d.png",
    "https://cdn.faire.com/fastly/fd23c7b75afd584d95688d9457b9263b71ec2d434fb6e4885625e446236740f0.jpeg",
    "https://cdn.faire.com/fastly/24fa4f31c64bd7221ba2d1e738a5bc402cb13f0fd5a673663b232339d137162a.jpeg",
    "https://cdn.faire.com/fastly/dcce487cf8aae374c9c49691bdb1cb7d0cd8aa0ceaeb532295c0edf7c19ceb53.jpeg",
    "https://cdn.faire.com/fastly/2135f050258d78f02be8d712c30a3969eb47ef0f374224048064755ea70503e0.png",
  ],
  priceDollars: 6.64,
  description:
    "In the spirit of balance, Eidon is introducing our newest product - a decadently guilt-free chocolate bar! Our chocolate is sweetened with xylitol from birch trees and enhanced with a touch of Peruvian Pink Salt. Our salt is hand harvested high in the Andes, where it bubbles up from natural springs, resulting in a pure, mineral-rich salt that is a perfect balance to our zero-sugar dark chocolate. \n\nWith just four ingredients, you get all of the nutrients found in dark chocolate, and a full complement of minerals without any sugar!\n\nAttributes:\n\n- Sweetened with Xylitol\n- Enhanced with a touch of Peruvian Pink Salt \n- Gluten Free - Soy Free - Sugar Free - Keto Friendly - No fillers - No Preservatives\n- Clean Ingredients: Organic Cacao, Non-GMO Birch Xylitol, Organic Cacao Butter, Peruvian Salt",
  tags: [],
  msrpDollars: 11.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:28.304Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
